"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiDefaultResponse = exports.ApiUnsupportedMediaTypeResponse = exports.ApiUnprocessableEntityResponse = exports.ApiServiceUnavailableResponse = exports.ApiRequestTimeoutResponse = exports.ApiPayloadTooLargeResponse = exports.ApiPreconditionFailedResponse = exports.ApiNotImplementedResponse = exports.ApiNotAcceptableResponse = exports.ApiMethodNotAllowedResponse = exports.ApiGoneResponse = exports.ApiGatewayTimeoutResponse = exports.ApiForbiddenResponse = exports.ApiConflictResponse = exports.ApiBadGatewayResponse = exports.ApiInternalServerErrorResponse = exports.ApiNotFoundResponse = exports.ApiTooManyRequestsResponse = exports.ApiUnauthorizedResponse = exports.ApiBadRequestResponse = exports.ApiFoundResponse = exports.ApiMovedPermanentlyResponse = exports.ApiNoContentResponse = exports.ApiAcceptedResponse = exports.ApiCreatedResponse = exports.ApiOkResponse = exports.ApiResponse = void 0;
const helpers_1 = require("./helpers");
Object.defineProperty(exports, "ApiResponse", {
  enumerable: true,
  get: function () {
    return helpers_1.emptyDecorator;
  }
});
exports.ApiOkResponse = helpers_1.emptyDecorator;
exports.ApiCreatedResponse = helpers_1.emptyDecorator;
exports.ApiAcceptedResponse = helpers_1.emptyDecorator;
exports.ApiNoContentResponse = helpers_1.emptyDecorator;
exports.ApiMovedPermanentlyResponse = helpers_1.emptyDecorator;
exports.ApiFoundResponse = helpers_1.emptyDecorator;
exports.ApiBadRequestResponse = helpers_1.emptyDecorator;
exports.ApiUnauthorizedResponse = helpers_1.emptyDecorator;
exports.ApiTooManyRequestsResponse = helpers_1.emptyDecorator;
exports.ApiNotFoundResponse = helpers_1.emptyDecorator;
exports.ApiInternalServerErrorResponse = helpers_1.emptyDecorator;
exports.ApiBadGatewayResponse = helpers_1.emptyDecorator;
exports.ApiConflictResponse = helpers_1.emptyDecorator;
exports.ApiForbiddenResponse = helpers_1.emptyDecorator;
exports.ApiGatewayTimeoutResponse = helpers_1.emptyDecorator;
exports.ApiGoneResponse = helpers_1.emptyDecorator;
exports.ApiMethodNotAllowedResponse = helpers_1.emptyDecorator;
exports.ApiNotAcceptableResponse = helpers_1.emptyDecorator;
exports.ApiNotImplementedResponse = helpers_1.emptyDecorator;
exports.ApiPreconditionFailedResponse = helpers_1.emptyDecorator;
exports.ApiPayloadTooLargeResponse = helpers_1.emptyDecorator;
exports.ApiRequestTimeoutResponse = helpers_1.emptyDecorator;
exports.ApiServiceUnavailableResponse = helpers_1.emptyDecorator;
exports.ApiUnprocessableEntityResponse = helpers_1.emptyDecorator;
exports.ApiUnsupportedMediaTypeResponse = helpers_1.emptyDecorator;
exports.ApiDefaultResponse = helpers_1.emptyDecorator;
